import type { Map as MapboxMap } from 'mapbox-gl';

import type { ImageResource } from '@/types';

export const loadImages = async (
  map: MapboxMap,
  imageResources: ImageResource[]
): Promise<void> => {
  await Promise.all(
    imageResources.map(({ id, url }) => {
      return new Promise<void>((resolve, reject) => {
        if (map.hasImage(id)) {
          resolve();

          return;
        }

        map.loadImage(url, (error, image) => {
          if (error) {
            reject(error);

            return;
          }

          if (image) {
            map.addImage(id, image);
            resolve();
          }
        });
      });
    })
  );
};
